import { ApplicationState } from '../index';
import { EmailTenantsAccessStatus, TenantDescription } from '../../Models/Api/strongbox.financialportal';

export function GetAvailableTenants(state: ApplicationState): TenantDescription[] | undefined {
    if (!(state && state.multiTenant)) {
        return [];
    }
    return state.multiTenant.availableTenants?.tenants;
}

export function GetTenantAccessStatus(state: ApplicationState): EmailTenantsAccessStatus | undefined {
    if (!(state && state.multiTenant)) {
        return undefined;
    }
    return state.multiTenant.availableTenants?.accessStatus;
}